import { Component } from '@angular/core';
import { FormGroup , Validators} from '@angular/forms';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { BaseModalComponent } from 'src/app/core/base-modal.componant';
import { SessionService } from 'src/app/shared/services/session.service';
import { AddonService } from 'src/app/simulator-booking/services/addon.service';

@Component({
    selector: 'addon-create-model',
    templateUrl: './addon-create-model.component.html',
    styleUrl: './addon-create-model.component.scss',
    standalone: false
})
export class AddonCreateModelComponent extends BaseModalComponent {
  constructor(private sessionService: SessionService,
    private addonService: AddonService,
    public dialogRef: MatDialogRef<AddonCreateModelComponent>) {
    super();
  }

  public form = new FormGroup({
    name: new FormControl('', {
      validators: Validators.required
    }),
    description: new FormControl('', {  
      validators: Validators.required
    }),
    price: new FormControl(0, {
      validators: Validators.required
    }),
    isActive: new FormControl(true, {
      validators: Validators.required
    }),
    organizationId: new FormControl('', {
      validators: Validators.required
    }),
  });


  submit({value, valid}){
    if(valid){
      this.isLoading = true;
      value.createdBy = this.sessionService.getUserId();
      this.addonService.create(value).subscribe({
        next: (result) => {
          if(result !== null || result !== undefined){
            this.dialogRef.close("save");
          }
        },
        error: (error) => {
          this.isLoading = false;
          console.error(error);
          this.setError(error, this.form);
        },
        complete: () => this.isLoading = false
      });
    }
  }
}
